export abstract class DragWidgetServiceBase {
    protected messengerContainerElem: any;
    protected frameElem: any;
    protected indicatorElem: any;

    protected offset = [0, 0];
    protected isDown = false;

    protected triedCount = 0;

    protected lastMousePosition: [number, number] = [0, 0];
    protected documentDimension: [number, number] = [0, 0];
    protected edge = 20;
    protected framePointerEvents: any;

    protected documentMouseMoveHandlerContext = this.documentMouseMoveHandler.bind(this);
    protected documentMouseUpHandlerContext = this.documentMouseUpHandler.bind(this);
    protected windowResizeHandlerContext = this.windowResizeHandler.bind(this);
    protected messengerMouseDownHandlerContext = this.messengerMouseDownHandler.bind(this);
    protected dialogOffsetWith = 0;
    protected isCut = false;
    protected widthFromEdge = 0;

    public beginMoving() {
        // try to register handler, because intercom sometime is not ready yet.
        if (this.triedCount > 3) {
            return;
        }

        this.triedCount++;
        setTimeout(() => this.initEventListener(), 200);
    }

    protected abstract loadElements();

    protected initEventListener() {
        try {

            this.loadElements();

            this.setupMessengerStyle();
            this.framePointerEvents = this.frameElem.style.pointerEvents;
            this.documentDimension = [document.body.clientHeight, document.body.clientWidth];

            document.addEventListener('mousemove', this.documentMouseMoveHandlerContext);
            document.addEventListener('mouseup', this.documentMouseUpHandlerContext);
            window.addEventListener('resize', this.windowResizeHandlerContext);
            this.messengerContainerElem.addEventListener('mousedown', this.messengerMouseDownHandlerContext);

            // this calling for the case when the messenger is already open, then close it, move the browser to other smaller screen monitor.
            // Then open the messenger again. The messenger will be repositioned.
            this.reposition();
        } catch (error) {
            this.beginMoving();
        }
    }

    public setupMessengerStyle() {
        if (!this.indicatorElem) {
            this.indicatorElem = document.createElement("div");
            this.indicatorElem.className = 'messenger-indicator';
        }

        this.messengerContainerElem.insertBefore(this.indicatorElem, this.messengerContainerElem.firstChild);
    }

    public unregisterHandler() {
        document.removeEventListener('mousemove', this.documentMouseMoveHandlerContext);
        document.removeEventListener('mouseup', this.documentMouseUpHandlerContext);
        window.removeEventListener('resize', this.windowResizeHandlerContext);
        this.messengerContainerElem?.removeEventListener('mousedown', this.messengerMouseDownHandlerContext);
        this.messengerContainerElem?.removeChild(this.indicatorElem);

        this.messengerContainerElem = null;
        this.frameElem = null;
        this.triedCount = 0;
    }


    public documentMouseMoveHandler(e: MouseEvent) {
        e.preventDefault();
        if (this.isDown) {
            const x = e.clientX;
            const y = e.clientY;

            const height = this.documentDimension[0];
            const width = this.documentDimension[1];
            if (x < this.edge || x > width - this.edge || y < this.edge || y > height - this.edge) {
                return;
            }

            this.lastMousePosition = [x, y];

            this.messengerContainerElem.style.left = (x + this.offset[0]) + 'px';
            this.messengerContainerElem.style.top = (y + this.offset[1]) + 'px';
        }
    }

    public messengerMouseDownHandler(e: MouseEvent) {
        e.preventDefault();
        this.frameElem.style.pointerEvents = 'none';

        this.isDown = true;
        this.offset = [
            this.messengerContainerElem.offsetLeft - e.x,
            this.messengerContainerElem.offsetTop - e.y
        ];
    }

    public documentMouseUpHandler(e: MouseEvent) {

        this.isCut = false;
        this.dialogOffsetWith = this.messengerContainerElem.offsetLeft + this.messengerContainerElem.clientWidth;

        if (this.dialogOffsetWith > this.documentDimension[1]) {
            this.widthFromEdge = this.messengerContainerElem.clientWidth - (this.dialogOffsetWith - this.documentDimension[1]);
            this.isCut = true;
        }
        else {
            this.widthFromEdge = this.messengerContainerElem.offsetLeft + (this.messengerContainerElem.clientWidth / 3);
        }

        this.frameElem.style.pointerEvents = this.framePointerEvents;
        this.isDown = false;
        e.preventDefault();
    }

    public windowResizeHandler(event: Event) {

        this.documentDimension = [document.body.clientHeight, document.body.clientWidth];
        this.reposition();
    }

    public reposition() {
        const height = this.documentDimension[0];
        const width = this.documentDimension[1];

        if (this.dialogOffsetWith > width) {
            if (this.isCut) {
                this.messengerContainerElem.style.left = (width - this.widthFromEdge) + 'px';
            }
            else {
                if (this.widthFromEdge > width) {
                    this.messengerContainerElem.style.left = (width - (this.messengerContainerElem.clientWidth / 3)) + 'px';
                }
            }
        }

        if (this.lastMousePosition[1] > height) {
            this.messengerContainerElem.style.top = (height - 50) + 'px';
        }
    }
}